import type { ApolloCache } from '@apollo/client'

type CacheOperations = Pick<ApolloCache<unknown>, 'evict' | 'gc' | 'identify'>

export function upsertCompensationsEmployeesCompensationMutationCacheUpdater(
  cache: CacheOperations
) {
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'compensations' })
  cache.gc()
}

export function deleteCompensationsEmployeesCompensationMutationCacheUpdater(
  cache: CacheOperations,
  compensationId: string
) {
  const entityId = cache.identify({
    __typename: 'CompensationsEmployeesCompensation',
    id: compensationId,
  })

  if (entityId) {
    cache.evict({ id: entityId })
  }

  cache.evict({ id: 'ROOT_QUERY', fieldName: 'compensations' })
  cache.gc()
}
